import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { Alliance } from 'src/app/interfaces/alliance.interface';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-alliance-list',
  templateUrl: './alliance-list.component.html',
})
export class AllianceListComponent implements OnInit {
  alliances: Alliance[] | undefined;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadAlliances();
  }

  async loadAlliances() {
    try {
      this.alliances = await this.apiService.fetchAlliances();
    } catch (error) {
      handleApiError(this.authService, this.router, error);
    }
  }
}
